
<script>
	export let noshadow=false
</script>
<div class="bg-white pl-6 pr-5 py-5 rounded-3xl mb-1 
{noshadow ? '' : 'shadow-[0_5px_6px_0px_rgb(72,38,38,0.03),0_18px_17px_0px_rgb(72,38,38,0.04),0_50px_50px_0px_rgb(72,38,38,0.02)]'}
 ">
	<slot></slot>
</div>

